<template>
   <div class="col-xl-4 col-lg-3 col-md-6">
      <div class="product-bar m-b-30">
         <div class="product-head">
            <img :src="url" class="img-fluid" alt="product">
            <p class="pt-2"><span class="badge font-14" :class="badgeClass">{{promotion.applicable_quantity}} disponibles</span></p>
         </div>
         <div class="product-body py-2">
            <div class="row align-items-center">
               <div class="col-12">
                  <h5 class="mt-1 mb-3">{{promotion.name}}</h5>
               </div>
            </div>
            <div class="row align-items-center mb-3">
               <div class="col-12">
                  <div class="d-inline-block">
                     <span class="text-uppercase font-12 f-w-6">{{ descripcionGeneralPromocion(promotion)}}</span>
                  </div>
               </div>
            </div>
            <div class="row align-items-center mt-1">
               <!--div class="col-6">
                  <div class="text-left">
                     <h4 class="mb-1">${{formattedCost}}</h4>
                  </div>
               </div-->
               <div class="col-12">
                  <div class="text-left">
                     <button type="button" class="btn btn-primary-rgba font-18" @click.stop="onCartBtn"><i class="feather icon-shopping-cart mr-2"></i> Agregar</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import {Promotion} from "../../classes/promotion"
import formatHelper from "@mixins/formatHelper"
import promotionsHelper from "@mixins/promotionsHelper"
export default {
   name: "PurchasePromotionCard",
   props: {
     promotion: Promotion
   },
   mixins: [formatHelper, promotionsHelper],
   data() {
      return {
         default_img_url: "https://i.ibb.co/wwCRmH7/blog-slide-02.jpg",
         //default_img_url: "https://img.sidi-e.com/4070017.png",
         defaultImage: require('@assets/images/products/product-default.jpg'),
      }
   },
   methods: {
      async onCartBtn(){
         await this.$emit('on-cart-action', this.promotion.id);
      }
   },
   computed: {
      formattedCost(){
         return 0;// this.fixedFormat(this.stringToFloat(this.product.cost), 2)
      },
      badgeClass(){
         let c = "";
         if(this.promotion.applicable_quantity <= 3){
            c = "danger"
         }
         else if(this.promotion.applicable_quantity <= 10){
            c = "warning"
         }
         else {
            c = "success"
         }
         return `badge-${c}`;
      },
      url(){
         //return this.defaultImage // Product.getListImgUrl(this.product) ?? this.default_img_url
         //return Product.getListImgUrl(this.promotion) ?? this.default_img_url
         return this.promotion.url_imagen ?? this.defaultImage
      }
   }
}
</script>
